<template>
    <section>
      <el-form ref="form" label-position="right" status-icon :model="form" :rules="rules" label-width="170px" style="width:95%;overflow:auto">
        <el-form-item label="设备编号" prop="id">
          <el-input placeholder="请输入设备编号" v-model="form.id" :disabled="row ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="是否批量生成端口" prop="isAutoAddPort" v-if="!row">
          <el-radio-group v-model="form.isAutoAddPort">
             <el-radio-button :label="true">是</el-radio-button>
             <el-radio-button :label="false">否</el-radio-button>
           </el-radio-group>
        </el-form-item>
        <div v-if="form.isAutoAddPort">
          <el-form-item label="端口数量" prop="portQuantity">
            <el-input placeholder="请输入充电费用" v-model="form.portQuantity" type="number" @input="handleInput('portQuantity')"></el-input>
          </el-form-item>
          <el-form-item label="端口类型" prop="portType">
            <el-radio-group v-model="form.portType">
              <el-radio-button :label="1">充电</el-radio-button>
              <el-radio-button :label="2">充放电一体</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="所属商户" prop="merchantId" v-if="userInfo.roleLevel < 5 && ( (row && !row.merchantId) || !row)">
          <el-select v-model="form.merchantId" placeholder="请选择所属商户" @change="chooseMerchant">
            <el-option
              v-for="item in managerOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装小区" prop="unitId" v-if="userInfo.roleLevel <= 5">
          <el-select filterable remote v-model="form.unitId" clearable placeholder="请输入小区名称查询" :remote-method="getNieghbourList">
            <el-option
              v-for="item in neighbourhoodList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区内具体安装位置" prop="address">
          <el-input placeholder="请填写具体安装位置" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="充电费用（元/次）" prop="chargeFee">
          <el-input placeholder="请输入充电费用" v-model="form.chargeFee" type="number"></el-input>
        </el-form-item>
        <el-form-item label="充放电费用（元/次）" prop="chargeDischargeFee">
          <el-input placeholder="请输入充放电费用" v-model="form.chargeDischargeFee" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" >
          <el-input placeholder="请填写备注" v-model="form.remark" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="handleSubmit('form')" :plain='true'>立即提交</el-button>
        </el-form-item>
      </el-form>
    </section>
  </template>
  
  <script>
  import { getMerchantList,getNeighbourhoodList } from '@/api/public.js';
  import { addChargeDischarge,updateChargeDischarge } from "@/api/chargeDischargeApi.js";
  export default {
    props:['row'], // 父组件携带参数
    data() {
      return {
        form:{ // 表单数据
          id: "", // 设备编号
          name:"", // 设备名称
          chargeFee:"", // 制动最长运作时间
          chargeDischargeFee:"", // 测速最长运作时间
          portQuantity:0,
        },
        rules: { // 表单验证
          id:[
            { required: true, message: '设备编号不得为空', trigger: 'blur',}
          ],
          name:[
            { required: true, message: '设备名称不得为空', trigger: 'blur',}
          ],
          unitId:[
            { required:true,message:'安装小区不得为空',trigger:"blur"}
          ],
          merchantId:[
            { required:true,message:'所属商户不得为空',trigger:"blur"}
          ],
          address:[
            { required:true,message:'安装位置不得为空',trigger:"blur"}
          ],
          portQuantity:[
            { required:true,message:'请选择端口数量',trigger:"change"}
          ],
          chargeFee:[
            {required:true,message:'请输入充电费用',trigger:"blur"},
          ],
          chargeDischargeFee:[
            {required:true,message:'请输入充放电费用',trigger:"blur"},
          ],
        },
        managerOptions:[], // 商户列表
        neighbourhoodList:[], // 小区列表
        userInfo:JSON.parse(localStorage.getItem('userInfo')), // 当前登陆账号用户信息
      };
    },
  
    components: {},
  
    computed: {},
  
    mounted() {
      this.form = this.row ? { ...this.row } : this.form;
      // 根据当前登录账号角色，判断是否需要获取商户列表选项数据，角色权限小于5时，需要选择商户，大于5时，商户id默认为当前登录账号的商户id
      this.userInfo.roleLevel < 5 ? this.getMerchantOptions() : "";
      this.getNieghbourList(null);
    },
  
    methods: {
      /**
       * 数字输入框将String类型的数字转换为Number类型的数字
       * @param {*String} value 输入框双向绑定的表单对象对应的属性
       */
      handleInput(value){
        this.form[value] = Number(this.form[value]);
      },
      // 获取小区列表
      getNieghbourList(e){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:e,
            merchantId:this.form.merchantId,
          }
        }
        getNeighbourhoodList(data).then(res=>{
          if(res.success){
            this.neighbourhoodList = res.data.list;
          }
        })
      },
      // 获取商户列表
      async getMerchantOptions(){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:'',
          }
        }
        await getMerchantList(data).then(res=>{
          if(res.success){
            this.managerOptions = res.data.list;
          }else{
            this.managerOptions = [];
          }
        })
      },
      // 选择商户、小区
      chooseMerchant(e){
        this.form.merchantId = e;
        this.getNieghbourList();
      },
      // 关闭弹窗
      close(form){
         this.$emit('close');
      },
      // 新增
      async add(){
        await addChargeDischarge({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 编辑
      async edit(){
        await updateChargeDischarge({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 提交
      handleSubmit(form) {
         this.$refs["form"].validate(valid => {
            if (valid) {
                this.$confirm('确认提交吗？').then(()=>{
                  if(this.row){
                    this.edit();
                  }else{
                    this.form.portQuantity = this.form.isAutoAddPort ? this.form.portQuantity : 0;
                    this.add();
                  }
                })
            }else{
              return false;
            }
        });
      },
    }
  };
  </script>
  <style lang="scss" scoped>
  // 防止地图自动完成的对象被遮挡
  .tangram-suggestion {
      z-index: 9999 !important;
    }
   .el-drawer{
     overflow:auto !important;
   }
   /deep/ .el-form-item__content{
    display: flex;
   }
   .map{
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 4px;
    width: 80px;
   }
   .avatar-uploader .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      border: 1px dashed #ccc;
      border-radius: 50%;
      overflow:hidden;
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  </style>
  